module.exports = __webpack_public_path__ + "img/title_sp.69fa3f31.png";